<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [Filter] {{$t('sap_order')}}
                        </div>
                        <!-- <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />
                        </div> -->
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)" v-if="hasChecked"/>
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <TabView v-model:activeIndex="activeIndex">
                        <TabPanel header="Filter">
                            <div class="col-12">
                                <Message severity="error" :closable="true" v-if="filterMessage" @close="closeFilterMessage">{{filterMessage}}</Message>

                                <FormField :labelName="$t('order_type')" fieldName="Order_Type" v-model="filter_order_type" :skeleton="false" :required="true">
                                    <CustomSelect v-model="filter_order_type" :url="$API_URL + 'list/order_type'" :minLength="0" :params="{ }" @change="onChangeOrderType"/>
                                </FormField>

                                <div v-if="filter_order_type">
                                    <FormField :labelName="$t('transfer_type')" v-if="useTransfer" fieldName="Transfer_Type" v-model="filter_transfer_type" :skeleton="false" >
                                        <CustomSelect v-model="filter_transfer_type" :url="$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.STO_TRANSFER_TYPE }" :disabled="true"/>
                                    </FormField>

                                    <FormField :labelName="$t('doc_date')" fieldName="Doc_Date" v-model="filter_doc_date" :skeleton="false" :required="true">
                                        <DatePicker dateFormat="dd/mm/yy" class="p-inputtext-sm" v-model="filter_doc_date" selectionMode="range"/>
                                    </FormField>

                                    <FormField :labelName="$t('company')" fieldName="Company" v-model="filter_company" :skeleton="false" fieldClass="col-8" :required="true">
                                        <CustomMultiSelect v-model="filter_company" :url="$API_URL + 'list/company_code'" :params="{}" />
                                    </FormField>

                                    <FormField :labelName="$t('product_category')" fieldName="Product_Category" v-model="filter_product_category" :skeleton="false" fieldClass="col-8">
                                        <CustomMultiSelect v-model="filter_product_category" :url="$API_URL + 'list/business_segment_code'" :params="{}" />
                                    </FormField>

                                    <FormField :labelName="$t('sap_no')" fieldName="SAP_No" v-model="filter_sap_no" :skeleton="false" fieldClass="col-8">
                                        <CustomChips v-model="filter_sap_no" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                                    </FormField>

                                    <FormField :labelName="$t('plant')" fieldName="Plant" v-model="filter_plant" :skeleton="false" fieldClass="col-8">
                                        <CustomMultiSelect v-model="filter_plant" :url="$API_URL + 'list/plant_all'" :params={} />
                                    </FormField>

                                    <FormField :labelName="$t('material')" fieldName="Material" v-model="filter_material" :skeleton="false" fieldClass="col-8">
                                        <CustomMultiSelect 
                                            v-model="filter_material" 
                                            :url="this.$API_URL + 'list/material_code_v2'" 
                                            :minLength="0" 
                                            :params="{ company_code: companyCodes, plant_code: plantCodes, business_segment_code: businessSegmentCodes}" />
                                    </FormField>

                                    <FormField :labelName="$t('discharge_port')" v-if="useDischarge" fieldName="Discharge_Port" v-model="filter_discharge_port" :skeleton="false" fieldClass="col-8">
                                        <InputText name="Discharge_Port" v-model="filter_discharge_port" type="text" />
                                    </FormField>

                                    <FormField :labelName="$t('location')" v-if="useLocation" fieldName="Distribution" v-model="filter_location" :skeleton="false" fieldClass="col-8">
                                        <CustomMultiSelect v-model="filter_location" :url="$API_URL + 'list/location_code'" :params="{}" />
                                    </FormField>

                                    <FormField :labelName="$t('distribution')" v-if="useDistribution" fieldName="Distribution" v-model="filter_distribution" :skeleton="false" fieldClass="col-8">
                                        <CustomMultiSelect v-model="filter_distribution" :url="$API_URL + 'list/lookup'" :params="{ group: $LOOKUP_GROUP.DISTRIBUTION}" />
                                    </FormField>
                                    
                                    <FormField :labelName="$t('doc_type')" fieldName="Document_Type" v-model="filter_doc_type" :skeleton="false" fieldClass="col-8">
                                        <CustomMultiSelect v-model="filter_doc_type" :url="$API_URL + 'list/lookup'" :params="{ group: $LOOKUP_GROUP.DOCUMENT_TYPE}"  />
                                    </FormField>

                                    <FormField :labelName="$t('created_by')" fieldName="Created_By" v-model="filter_create_by" :skeleton="false" fieldClass="col-8">
                                        <CustomChips v-model="filter_create_by" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                                    </FormField> 

                                     <FormField :labelName="''" fieldName="" v-model="filter_order_type" :skeleton="false" fieldClass="col-2">
                                        <Button class="p-button-primary" label="Filter" @click="filterData"/>
                                    </FormField> 
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Result">
                            <Message severity="warn" :closable="false">{{$t('message.sap_filter_authorization')}}</Message>

                            <DataTable 
                                ref="dt" 
                                v-model:expandedRows="expandedRows"
                                @rowExpand="onRowExpand"
                                responsiveLayout="scroll" 
                                class="p-datatable-sm"
                                :value="result_data"
                                :loading="filtering"
                                :totalRecords="result_data.length"
                                :rowClass="authRowClass"
                                >
                            <Column :expander="true" field="" header="">
                                <template #header="">
                                    <Button :icon="allExpanderIcon" class="p-button-rounded p-button-text" @click="onExpandAll"/>
                                </template>
                            </Column>
                            <Column :exportable="false" :sortable="false">
                                <template #header="">
                                    <Checkbox v-model="check_all" :binary="true" @input="onCheckAll" />
                                </template>
                                <template #body="slotProps">
                                    <Checkbox v-model="slotProps.data.is_checked" :binary="true" :disabled="slotProps.data.disabled" />
                                </template>
                            </Column>
                            <Column field="document_date" :header="$t('document_date')" dataType="date">
                            </Column>
                            <Column field="delivery_order_no" :header="$t('delivery_order_no')">
                            </Column>
                            <Column field="document_no" :header="$t('document_no')" dataType="text">
                            </Column>
                            <Column field="customer_vendor" :header="$t('customer_vendor')">
                            </Column>
                            <Column field="po_no" :header="$t('po_no')">
                            </Column>
                            <Column field="ln_so_no" :header="$t('ln_so_no')">
                            </Column>
                            <Column field="ln_sto_no" :header="$t('ln_sto_no')">
                            </Column>
                            <Column field="incoterm" :header="$t('incoterm')">
                            </Column>
                            <Column field="estate" :header="$t('estate')">
                            </Column>
                            <Column field="plant" :header="$t('plant')">
                            </Column>
                            <Column field="distribution" :header="$t('distribution')">
                            </Column>
                            <Column field="document_type" :header="$t('document_type')">
                            </Column>
                            <Column field="company" :header="$t('company')">
                            </Column>
                            <Column field="product_category" :header="$t('product_category')">
                            </Column>
                            <Column field="purchase_organization" :header="$t('purchase_organization')">
                            </Column>
                            <Column field="sales_organization" :header="$t('sales_organization')">
                            </Column>
                            <Column field="collective_ln" :header="$t('collective_ln')">
                            </Column>
                            <Column field="transporter" :header="$t('transporter')">
                            </Column>
                            <Column field="loading" :header="$t('loading')">
                            </Column>
                            <Column field="destination" :header="$t('destination')">
                            </Column>
                            <Column field="freight_cost" :header="$t('freight_cost')">
                            </Column>
                            <Column field="freight_cost_base" :header="$t('freight_cost_base')">
                            </Column>
                            <Column field="freight_cost_per" :header="$t('freight_cost_per')">
                            </Column>
                            <Column field="freight_cost_uom" :header="$t('freight_cost_uom')">
                            </Column>
                            <Column field="truck_type" :header="$t('truck_type')">
                            </Column>
                            <Column field="incoterm2" :header="$t('incoterm2')">
                            </Column>
                            <Column field="ln_do_third_party" :header="$t('ln_do_third_party')">
                            </Column>
                            <Column field="valid_from" :header="$t('valid_from')">
                            </Column>
                            <Column field="valid_to" :header="$t('valid_to')">
                            </Column>
                            <Column field="mark_deleted" :header="$t('mark_deleted')">
                            </Column>
                            <template #expansion="slotProps">
                                <div class="orders-subtable">
                                    <DataTable :value="slotProps.data.details" responsiveLayout="scroll">
                                        <Column field="document_item_no" :header="$t('item_no')"  class="w-1"></Column>
                                        <Column field="commodity" :header="$t('commodity')" class="w-2"></Column>
                                        <Column field="qty" :header="$t('qty')"  class="w-1">
                                            <template #body="{data}">
                                                {{ $formatNumber(data.qty)}}
                                            </template>
                                        </Column>
                                        <Column field="uom" :header="$t('uom')" class="w-1"></Column>
                                        <Column field="so_do_no" :header="$t('so_do_no')" class="w-1"></Column>
                                        <Column field="so_do_item_no" :header="$t('so_do_item_no')" class="w-1"></Column>
                                        <Column field="po_so_no" :header="$t('po_so_no')" class="w-1"></Column>
                                        <Column field="ln_so_item_no" :header="$t('ln_so_item_no')" class="w-1"></Column>
                                        <Column field="ln_sto_item_no" :header="$t('ln_sto_item_no')" class="w-1"></Column>
                                        <Column field="freight_cost" :header="$t('freight_cost')" class="w-2" ></Column>
                                        <Column field="base_freight_cost" :header="$t('base_freight_cost')" class="w-1"></Column>
                                        <Column field="base_freight_per" :header="$t('base_freight_per')" class="w-1"></Column>
                                        <Column field="base_freight_uom" :header="$t('base_freight_uom')" class="w-1"></Column>
                                        <Column field="freight_cost_master" :header="$t('freight_cost_master')" class="w-1"></Column>
                                        <Column field="freight_value" :header="$t('freight_value')" class="w-1"></Column>
                                        <Column field="sto_qty" :header="$t('sto_qty')" class="w-1"></Column>
                                        <Column field="sto_uom" :header="$t('sto_uom')" class="w-1"></Column>
                                        <Column field="sales_district" :header="$t('sales_district')" class="w-1"></Column>
                                        <Column field="mark_delete" :header="$t('mark_deleted')" class="w-1"></Column>
                                    </DataTable>
                                </div>
                            </template>

                            </DataTable>
                        </TabPanel>
                    </TabView>
                </div>
                
            </template>
        </Card>
    </form>
</template>

<script>
    export default {
        name: "Editor",
        data() {
            return {
                indexName: "SAPOrderIndex",
                url: this.$API_URL + "saporder/",
                header: null,
                detail: null,
                mode: "",
                id: 0,
                activeIndex: 0,
                filtering: false,
                formEditable: true,
                filter_order_type: "",
                filter_transfer_type: "",
                filter_sap_no:[],
                filter_doc_date: [],
                filter_company: [],
                filter_product_category: [],
                filter_plant: [],
                filter_material: [],
                filter_discharge_port: "",
                filter_doc_type: [],
                filter_create_by: [],
                result_data:[],
                check_all: false,
                requireTransfer: false,
                requireDischarge: false,
                requireDocDate: false,
                requireCompany: false,
                requireSAPNo: false,
                useLocation: false,
                useDistribution: false,
                useTransfer: false,
                useDischarge:false,
                expandedRows: [],
                allExpanderIcon:"pi pi-fw pi-chevron-down",
                expandAll: false,
                filterMessage: ""
            }
        },
        methods: {
            onExpandAll(){
                if(this.result_data.length == 0)
                    return;

                if(this.expandAll){
                    this.expandedRows = [];
                    this.allExpanderIcon = "pi pi-fw pi-chevron-down";
                }
                else{
                    for(var i=0; i<this.result_data.length;i++){
                        this.expandedRows.push(this.result_data[i]);
                    }
                    this.allExpanderIcon = "pi pi-fw pi-chevron-up";
                }

                this.expandAll = !this.expandAll;
            },
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.header = response.data.data.header;
                    })
                    .catch(function (error) {
                        alert(error);
                    });
            },
            saveData() {
                this.$emit('block-ui');
                var self = this;
                this.$axios.post(this.url + "save_filter", this.result_data)
                    .then((response) => {
                        if (response.data.success) {
                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "SAP Order has been saved successfully", life: 120000 } } );
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            backToIndex() {
                this.$router.push({ path: "/SAPOrder/Index" });
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            confirm(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            filterData(){
                if(this.requireSAPNo && this.filter_sap_no.length == 0){
                    this.showError("Validation error", "SAP No. is required");
                    return;
                }
                else{
                    if(this.filter_sap_no.length == 0){
                        if(this.requireTransfer && !this.filter_transfer_type){
                            this.showError("Validation error", "Transfer type is required");
                            return;
                        }

                        if(this.requireDischarge && !this.filter_discharge_port){
                            this.showError("Validation error", "Discharge port is required");
                            return;
                        }

                        if(this.requireCompany && this.filter_company.length == 0){
                            this.showError("Validation error", "Company is required");
                            return;
                        }

                        if(this.requireDocDate && this.filter_doc_date.length == 0){
                            this.showError("Validation error", "Doc. date is required");
                            return;
                        }
                    }
                }

                this.filtering = true;

                var filterData = {
                    filter_order_type: this.filter_order_type,
                    filter_transfer_type: this.filter_transfer_type,
                    filter_sap_no : this.filter_sap_no,
                    filter_document_date_from : this.filter_doc_date[0] ? this.filter_doc_date[0] : null,
                    filter_document_date_to: this.filter_doc_date[1] ? this.filter_doc_date[1] : null,
                    filter_company: this.filter_company,
                    filter_location: this.filter_location,
                    filter_document_type: this.filter_document_type,
                    filter_business_segment: this.filter_business_segment,
                    filter_plant : this.filter_plant,
                    filter_distribution : this.filter_distribution,
                    filter_material: this.filter_material,
                    filter_create_by: this.filter_create_by,
                    filter_discharge_port: this.filter_discharge_port
                };
                this.$emit('block-ui');
                this.filterMessage = "";
                
                var self = this;
                this.$axios.post(this.url + "filter", filterData)
                    .then((response) => {
                        if (response.data.success) {
                            //this.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                            self.result_data = response.data.data;
                            self.filtering = false;
                            self.activeIndex = 1;
                            self.$emit("unblock-ui");
                        }
                        else {
                            self.filterMessage = response.data.message;
                            self.$emit("unblock-ui");
                            //self.showError('Error Filtering Data', response.data.message);
                        }
                        
                    })
                    .catch(function (error) {
                        self.showError('Error Filtering Data', error);
                        self.$emit("unblock-ui");
                    });

            },
            onCheckAll(event){
                //console.log(event);
                if(this.result_data.length > 0){
                    for(var i=0; i< this.result_data.length;i++){
                        if(!this.result_data[i].disabled)
                            this.result_data[i].is_checked = event;
                    }            
                }
            },
            onPaste(event, type){
                


            },
            reset(){
                this.requireDocDate = false;
                this.requireCompany = false;
                this.useLocation = false;
                this.useDistribution = false;
                this.useTransfer = false;
                this.requireTransfer = false;
                this.requireSAPNo = false;
                this.requireDischarge = false;
            },
            onChangeOrderType(event){
                var data = {
                    id: event.id
                };

                var self = this;

                this.reset();
                
                this.$axios.get(this.$UTIL_URL + "order_type_fields",  { params: data })
                    .then((response) => {
                        var data = response.data.data;

                        if(data.Use_SO || data.Use_LN){
                            self.requireDocDate = true;
                            self.requireCompany = true;

                            self.useLocation = true;
                            self.useDistribution = true;
                        }

                        if(data.Use_STO){
                            self.requireTransfer = true;
                            self.requireDocDate = true;
                            self.requireCompany = true;

                            self.useTransfer = true;
                            self.filter_transfer_type = data.Info1;

                        }
                        else if(data.Info1){
                            self.useTransfer = true;
                            self.filter_transfer_type = data.Info1;

                        }
                        else{
                            self.filter_transfer_type = "";
                        }

                        if(data.Use_GR){
                            self.requireCompany = true;
                            self.requireDischarge = true;
                            self.requireDocDate = true;

                            self.useDischarge=true;
                        }
                        else if(this.Use_PO){
                            self.requireSAPNo = true;
                        }
                        else if(this.Use_DO){
                            self.requireCompany = true;
                            self.requireDocDate = true;

                            self.useLocation = true;
                            self.useDistribution = true;
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Getting Order Type', error);
                    });
            },
            closeFilterMessage(event){
                this.filterMessage = "";
            },
            authRowClass(data){
                return data.disabled ? "row-unauthorized" : "";
            }
        },
        created() {
            //this.getData();
        },
        computed:{
            hasChecked(){
                if(this.result_data == null || this.result_data.length <= 0)
                    return false;

                var check = false

                for(var i=0; i< this.result_data.length;i++){
                    check = this.result_data[i].is_checked;

                    if(check)
                    {
                        break;
                    }
                }    
                return check;
            },
            companyCodes(){
                return this.filter_company.length == 0? "" : this.filter_company.join(";");
            },
            plantCodes(){
                return this.filter_plant.length == 0? "" : this.filter_plant.join(";");
            },
            businessSegmentCodes(){
                return this.filter_product_category.length == 0? "" : this.filter_product_category.join(";");
            }
        }
    }
</script>
<style scoped>
    .p-inputtext-sm .p-inputtext {
        padding:0.25rem!important;
    }

    .p-chips .p-chips-multiple-container {
        padding: 0.25rem 0.5rem!important;
    }

    
</style>